/**
 * undercover® — bento: getallen tellen op zodra de tegel in beeld komt (reduced motion: direct),
 * video-tegels spelen gedempt af als ze in beeld zijn.
 */
if (!customElements.get('uc-bento')) {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // "8,3" → { value: 8.3, decimals: 1, comma: true }
  const parse = (raw) => {
    const text = String(raw).trim();
    if (!/^\d+(?:[.,]\d+)?$/.test(text)) return null;
    const comma = text.includes(',');
    const [, frac = ''] = text.split(/[.,]/);
    return { value: parseFloat(text.replace(',', '.')), decimals: frac.length, comma };
  };

  const format = (n, { decimals, comma }) => {
    const out = n.toFixed(decimals);
    return comma ? out.replace('.', ',') : out;
  };

  class UcBento extends HTMLElement {
    connectedCallback() {
      this.counters = [...this.querySelectorAll('[data-count]')]
        .map((el) => ({ el, spec: parse(el.dataset.count) }))
        .filter((c) => c.spec);
      this.videos = [...this.querySelectorAll('video')];

      if (!('IntersectionObserver' in window) || reduce() || document.documentElement.classList.contains('shopify-design-mode')) {
        this.counters.forEach(({ el }) => (el.textContent = el.dataset.count));
      } else {
        this.counters.forEach(({ el, spec }) => (el.textContent = format(0, spec)));
        this.countObserver = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.countObserver.unobserve(entry.target);
              const counter = this.counters.find((c) => c.el === entry.target);
              if (counter) this.count(counter);
            }
          },
          { threshold: 0.6 }
        );
        this.counters.forEach(({ el }) => this.countObserver.observe(el));
      }

      if (this.videos.length && 'IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            const video = entry.target;
            if (entry.isIntersecting && !reduce()) video.play().catch(() => {});
            else video.pause();
          }
        }, { threshold: 0.35 });
        this.videos.forEach((video) => {
          video.muted = true;
          this.videoObserver.observe(video);
        });
      }
    }

    disconnectedCallback() {
      this.countObserver?.disconnect();
      this.videoObserver?.disconnect();
    }

    count({ el, spec }) {
      const duration = 1100 + Math.min(spec.value, 500);
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 4);
        el.textContent = format(spec.value * eased, spec);
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = el.dataset.count;
      };
      requestAnimationFrame(tick);
    }
  }

  customElements.define('uc-bento', UcBento);
}
